var phone_number = {};
module['exports'] = phone_number;
phone_number.formats = require("./formats");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/ge/phone_number/index.js
 ** module id = 634
 ** module chunks = 0
 **/